import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface ProtectedRouteProps {
  children: ReactNode
  requireCompany?: boolean
  allowedRoles?: ('owner' | 'admin' | 'collaborator')[]
}

export default function ProtectedRoute({ 
  children, 
  requireCompany = false,
  allowedRoles 
}: ProtectedRouteProps) {
  const { user, loading, currentCompany, userRole } = useAuth()
  const location = useLocation()

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="min-h-screen page-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  // Se não está autenticado, redirecionar para login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Se requer empresa mas não tem empresa selecionada
  if (requireCompany && !currentCompany) {
    return (
      <div className="min-h-screen page-bg flex items-center justify-center">
        <div className="card p-8 text-center max-w-md">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Empresa necessária
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Você precisa estar associado a uma empresa para acessar esta página.
          </p>
          <Navigate to="/companies" replace />
        </div>
      </div>
    )
  }

  // Se tem roles permitidos mas usuário não tem permissão
  if (allowedRoles && userRole && !allowedRoles.includes(userRole)) {
    return (
      <div className="min-h-screen page-bg flex items-center justify-center">
        <div className="card p-8 text-center max-w-md">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Acesso negado
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Você não tem permissão para acessar esta página.
          </p>
          <button 
            onClick={() => window.history.back()}
            className="btn-primary"
          >
            Voltar
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
